// bao migrate skip
import * as $ from "jquery";
import * as ko from "knockout";
import Bao from "../../../services/bao-service";
import BaoRouter from "../../../services/bao-router";
import finitoService from "../../../services/finito-service";
import BaoDialog from "../../../factories/bao-dialog";

function RoleInstructionRecipientRole(tabpage, parent) {
    var self = this;
    self.TabPage = tabpage;
    self.Role = parent;
    self.initialized = false;
    self.InstructionRecipientCollection = ko.observableArray([]);
    self.Sorting = ko.observableArray([]);
    self.PageIndex = ko.observable(0);
    self.PageSize = ko.observable(10);
    self.TotalRows = ko.observable(0);
    self.SelectedInstructionRecipientRow = ko.observable();
    self.ToolbarButtons = ko.observableArray([]);
    self.ShowRoleDialog = function () { };
    self.SelectedRole = ko.observableArray();
    self.SelectedRoleIds = ko.observableArray();
    self.baoSearcherItems = ko.observableArray([]);
    self.SelectedRole.subscribe(function () {
        if (self.SelectedRole() === null || self.SelectedRole().length == 0) {
            return;
        }
        self.AddRoleInstructionRecipientRole(self.SelectedRole(), self.Role.RoleId()).then(function () {
            self.loadInstructionRecipientCollection();
            self.SelectedRole([]);
            self.baoSearcherItems([]);
        });
    });
    self.Sorting.subscribe(function () {
        self.loadInstructionRecipientCollection();
    });
    self.PageIndex.subscribe(function () {
        self.loadInstructionRecipientCollection();
    });
    self.SelectedInstructionRecipientRow.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.ToolbarButtons.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.SelectInstructionRecipientRow = function (clickedRow) {
        this.SelectedInstructionRecipientRow(clickedRow);
        return true;
    };
    self.ShowInstructionRecipientRole = function (item) {
        var linkHash = "uadm/role/" + ko.unwrap(item.InstructionRecipientRoleId);
        BaoRouter.setHash(linkHash);
    };
    self.CompleteCheck = function () {
        return true;
    };
    self.resetServerCollection = function () {
        return Bao.post("UadmFinitoCustom/RoleTab/ResetRoleInstructionRecipientRoleServiceProviderCollection", JSON.stringify({
            sessionTabId: ko.unwrap(self.Role.TabPage.SessionTabId)
        }));
    };
    self.loadInstructionRecipientCollection = function (forceRefresh) {
        if (self.initialized !== true && forceRefresh !== true) {
            return;
        }
        return Bao.post("UadmFinitoCustom/RoleTab/GetInstructionRecipientCollection", JSON.stringify({
            sessionTabId: ko.unwrap(self.Role.TabPage.SessionTabId),
            roleId: ko.unwrap(self.Role.RoleId),
            searchFilter: "",
            pageIndex: ko.unwrap(self.PageIndex),
            pageSize: ko.unwrap(self.PageSize),
            sorting: ko.unwrap(self.Sorting)
        }), function (data) {
            self.TotalRows(data.TotalRows);
            self.InstructionRecipientCollection(data.Models);
        });
    };
    self.MinifyTaskRecipients = function (taskRecipients) {
        taskRecipients = ko.unwrap(taskRecipients);
        if (taskRecipients == null || taskRecipients == false || taskRecipients.length == 0) {
            return [];
        }
        var result = [];
        for (var i in taskRecipients) {
            if (taskRecipients[i].ShiftbookId != "" && taskRecipients[i].ShiftbookId != null) {
                result.push(taskRecipients[i].ShiftbookId);
            }
            else {
                result.push(taskRecipients[i].RoleId);
            }
        }
        return result;
    };
    self.AddRoleInstructionRecipientRole = function (instructionRecipientRoleIds, roleId) {
        return Bao.post("UadmFinitoCustom/RoleTab/AddInstructionRecipientRole", JSON.stringify({
            sessionTabId: ko.unwrap(self.Role.TabPage.SessionTabId),
            roleId: roleId,
            instructionRecipientRoleIds: self.MinifyTaskRecipients(instructionRecipientRoleIds)
        }), function (data) {
            self.Role.TabPage.DirtyFlag(true);
            if (data !== true) { }
        });
    };
    self.DeleteRoleInstructionRecipientRole = function (roleInstructionRecipientRoleId, roleId) {
        var def = $.Deferred();
        Bao.post("UadmFinitoCustom/RoleTab/DeleteInstructionRecipientRole", JSON.stringify({
            sessionTabId: ko.unwrap(self.Role.TabPage.SessionTabId),
            roleId: roleId,
            roleInstructionRecipientRoleId: roleInstructionRecipientRoleId
        }), function (data) {
            self.Role.TabPage.DirtyFlag(true);
            if (data !== true) { }
            def.resolve();
        });
        return def.promise();
    };
    self.Save = function () {
        return Bao.post("UadmFinitoCustom/RoleTab/SaveRoleInstructionRecipientRoleServiceProviderCollection", JSON.stringify({
            sessionTabId: self.Role.TabPage.SessionTabId,
            roleId: self.Role.RoleId(),
            saveTime: parent.SaveTime()
        }));
    };
    self.Refresh = function (forceRefresh) {
        var def = $.Deferred();
        if (self.initialized !== true && forceRefresh !== true) {
            return;
        }
        self.TabPage.IsLoading(true);
        self.SelectedInstructionRecipientRow(null);
        self.resetServerCollection().then(function () {
            self.loadInstructionRecipientCollection(forceRefresh).then(function () {
                self.TabPage.IsLoading(false);
                def.resolve();
            });
        });
        return def.promise();
    };
    self.toolbarClick = function (btnClicked) {
        switch (ko.unwrap(btnClicked.ActionKey)) {
            case "RoleInstructionRecipientAdd":
                self.ShowRoleDialog();
                break;
            case "RoleInstructionRecipientDelete":
                var dialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage(finitoService.MessageKeys.RoleInstructionRecipientRoleDeletePrompt), "yesno");
                dialog.DialogResult.subscribe(function (dialogResult) {
                    if (dialogResult === true) {
                        self.DeleteRoleInstructionRecipientRole(ko.unwrap(self.SelectedInstructionRecipientRow).RoleInstructionRecipientRoleId, ko.unwrap(self.Role.RoleId)).then(self.loadInstructionRecipientCollection);
                    }
                });
                break;
            case "RoleInstructionRecipientEdit":
                self.ShowInstructionRecipientRole(ko.unwrap(self.SelectedInstructionRecipientRow));
                break;
        }
    };
    self.ToggleToolbarButtons = function () {
        ko.utils.arrayForEach(self.ToolbarButtons(), function (button: any) {
            switch (button.ActionKey()) {
                case "RoleInstructionRecipientEdit":
                case "RoleInstructionRecipientDelete":
                    button.Enabled(!(self.SelectedInstructionRecipientRow() == null));
                    break;
                case "RoleInstructionRecipientAdd":
                    button.Enabled(!self.Role.IsNew());
                    break;
            }
        });
    };
    self.init = function () {
        self.Refresh(true);
    };
    self.loaded = function () {
        self.initialized = true;
    };
    self.dispose = function () { };
}
;
export default RoleInstructionRecipientRole;